module.exports = __webpack_public_path__ + "static/media/my-profile.c1011461.svg";